import React from 'react';

interface TwoDBoxesIconV2Props {
  style?: React.CSSProperties;
}

const TwoDBoxesIconV2: React.FC<TwoDBoxesIconV2Props> = ({ style }) => {
  return <img style={style} src="/static/images/image-annotation.png" />;
};

export default TwoDBoxesIconV2;
